<template>
  <div class="storeApply">
    <!-- 基本信息 -->
    <div class="list">
      <div class="item flex ali_center">
        <div class="left">订单号</div>
        <input
          type="text"
          v-model="order_id"
          disabled
          placeholder="请填写订单号"
          placeholder-style="color: #ccc;font-size:0.30rem"
        />
      </div>
      <div class="item flex ali_center">
        <div class="left">姓名</div>
        <input
          type="text"
          v-model="real_name"
          placeholder="请填写姓名"
          placeholder-style="color: #ccc;font-size:0.30rem"
        />
      </div>
      <div class="item flex ali_center">
        <div class="left">年龄</div>
        <input
          type="number"
          v-model="age"
          placeholder="请填写年龄"
          placeholder-style="color: #ccc;font-size:0.30rem"
        />
      </div>
      <div class="item flex ali_center" @click="show_add4 = true">
        <div class="left">性别</div>
        <input
          type="text"
          disabled
          v-model="choose_name3"
          placeholder="请选择商户类型"
          placeholder-style="color: #333;font-size:0.30rem"
        />
      </div>
      <div class="item flex ali_center">
        <div class="left">身份证号</div>
        <input
          type="text"
          v-model="card_id"
          placeholder="请填写身份证号"
          placeholder-style="color: #ccc;font-size:0.30rem"
        />
      </div>

      <div class="item flex ali_center">
        <div class="left">电话</div>
        <input
          type="number"
          v-model="phone"
          placeholder="请填写电话"
          placeholder-style="color: #ccc;font-size:0.30rem"
        />
      </div>
      <div class="item flex ali_center">
        <div class="left">所需团队</div>
        <input
          type="text"
          v-model="team"
          placeholder="请填写所需团队"
          placeholder-style="color: #ccc;font-size:0.30rem"
        />
      </div>

      <div class="item2 flex ali_center" @click="showAddress = true">
        <div class="left">地址</div>
        <div class="right flex ali_center flex_between">
          <spen class="a">{{ addressText }}</spen>
          <spen class="iconfont icon-dizhi"></spen>
        </div>
      </div>
      <div class="item flex ali_center">
        <div class="left">详细地址</div>
        <input
          type="text"
          v-model="detail"
          placeholder="请填写详细地址"
          placeholder-style="color: #ccc;font-size:0.30rem"
        />
      </div>
    </div>
    <div class="submit" @click="submit(1)">提交</div>
    <!-- <div class="examine" @click="$goNext('/pages/store/record')">
      查看审核记录
    </div> -->
    <div v-if="showAddress">
      <CitySelect
        ref="cityselect"
        v-model="showAddress"
        :callback="result"
        :items="addressList"
        :ready="ready"
        provance=""
        city=""
        area=""
      ></CitySelect>
    </div>
    <gender7
      :show_add="show_add4"
      :gender="choose_name3"
      @show_gender="show_add4 = false"
      @carefuls="carefuls3"
    >
    </gender7>
  </div>
</template>

<script>
import { kcInfoUpdate, kcInfo } from "../../api/order";
import { getCity } from "@api/public";
import gender7 from "@components/public/gender7.vue";
import { CitySelect } from "vue-ydui/dist/lib.rem/cityselect";
export default {
  name: "storeApply4",
  components: { gender7, CitySelect },
  data() {
    return {
      baseline: false,
      choose_name3: "请选择性别",
      addressText: "请选择地址",
      type: 0,
      type2: 1,
      status: -1,
      statusmsg: "",
      signUrl: "",
      checked: false,
      showAddress: false,
      showAddress3: false,
      valueArr: [0, 0, 0],
      valueArr3: [0, 0],
      id: 0,
      uid: "",
      ready: false,
      addressList: [],
      realname: "",
      province_code: "",
      city_code: "",
      district_code: "",
      province2: "",
      city2: "",
      district2: "",
      contact_line: [],
      show_add3: false,
      combo: 0,
      branch: "",
      stick: "请选择让利比例",
      address_jw: "",
      showAddress2: false,
      addressList2: [],
      addressList3: [],
      showStreet: false,
      show_add: false,
      show_add2: false,
      // show_add3: false,
      show_add5: false,
      show_add6: false,
      show_add4: false,
      start: false,
      open: false,
      subMercList: [],
      order_id: "",
      real_name: "",
      gender: "",
      age: "",
      card_id: "",
      team: "",
      phone: "",
      address: "",
      detail: "",
      province: "",
      city: "",
      district: ""
    };
  },

  mounted() {
    this.order_id = this.$route.query.order_id;
    this.type = this.$route.query.type;
    this.getinitialMercInfo2();
    this.getCity();
  },
  methods: {
    getinitialMercInfo2() {
      let that = this;
      kcInfo()
        .then(res => {
          if (res.data.real_name) {
            that.real_name = res.data.real_name;
            that.gender = res.data.gender;
            that.choose_name3 = res.data.gender == 2 ? "女" : "男";
            that.age = res.data.age;
            that.card_id = res.data.card_id;
            that.team = res.data.team;
            that.phone = res.data.phone;
            that.province2 = res.data.address.province;
            that.city2 = res.data.address.city;
            that.district2 = res.data.address.district;
            that.addressText =
              that.province2 + " " + that.city2 + " " + that.district2;
            that.detail = res.data.address_detail;
          }
        })
        .catch(res => {
          that.$dialog.error(res.msg);
          that.$router.go(-1);
        });
    },

    carefuls3(res) {
      this.gender = res;
      this.choose_name3 = res == "2" ? "女" : "男";
      this.show_add4 = false;
      this.type2 = res;
    },
    onclick4() {
      this.show_add6 = true;
    },
    onclick3() {
      this.show_add5 = true;
    },
    onclick2() {
      this.show_add2 = true;
    },

    onclick() {
      this.show_add = true;
    },
    checkeds() {
      this.checked = !this.checked;
    },
    Combo(type) {
      this.combo = type.num;
      this.stick = type.name;
      this.show_add3 = false;
    },
    showCombo() {
      this.show_add3 = false;
    },

    result(ret) {
      console.log(ret);
      this.province2 = ret.itemName1;
      this.city2 = ret.itemName2;
      this.district2 = ret.itemName3;
      this.province_code = ret.itemValue1;
      this.city_code = ret.itemValue2;
      this.district_code = ret.itemValue3;
      this.addressText =
        ret.itemName1 + " " + ret.itemName2 + " " + ret.itemName3;
      this.cityId = ret.itemValue2;
      this.address = {
        province: this.province2,
        city: this.city2,
        district: this.district2,
        city_id: this.cityId
      };
      // this.gettreea(ret.itemName2, ret.itemName3);
    },
    getCity() {
      getCity()
        .then(res => {
          // this.recity(res.data);
          this.addressList = res.data;
          this.ready = true;
        })
        .catch(res => {
          console.log(res);
        });
    },

    recity(arr) {
      let province = [],
        city = [],
        area = [];
      if (arr.length) {
        let citychildren = arr[0].c || [];
        let areachildren = citychildren.length ? citychildren[0].c || [] : [];
        arr.forEach(item => {
          province.push(item);
        });
        citychildren.forEach(item => {
          city.push(item);
        });
        areachildren.forEach(item => {
          area.push(item);
        });
        this.province = province;
        this.city = city;
        this.district = area;
      }
    },
    submit() {
      let that = this;
      let data = {
        order_id: that.order_id,
        real_name: that.real_name,
        gender: that.gender,
        age: that.age,
        card_id: that.card_id,
        team: that.team,
        phone: that.phone,
        address: {
          province: that.province2,
          city: that.city2,
          district: that.district2
        },
        address_detail: that.detail
      };
      kcInfoUpdate(data)
        .then(res => {
          that.$dialog.success(res.msg);
          if (that.type == 1) {
            that.$router.replace({
              path: "/order/status/" + that.order_id + "/8"
            });
          } else {
            setTimeout(() => {
              that.$router.go(-1);
            }, 1500);
          }
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.storeApply {
  padding-bottom: 0.1rem;

  .list {
    background-color: #fff;

    .item2 {
      padding: 0 0.22rem;
      height: 0.9rem;
      background-color: #fff;
      font-size: 0.28rem;
      border-bottom: 0.01rem solid #eee;

      .left {
        width: 1.95rem;
        // color: #333;
      }

      .right {
        width: 6rem;

        .iconfont {
          color: #0e98fd;
          font-size: 0.5rem;
        }

        .icon-jinru {
          color: #666;
          font-size: 0.36rem;
        }
      }
    }

    .item {
      min-height: 0.99rem;
      border-bottom: 0.01rem solid #dcdcdc;
      padding: 0 0.23rem;

      .left {
        width: 2rem;
        font-size: 0.3rem;
        line-height: 0.99rem;
      }

      input,
      picker {
        font-size: 0.3rem;
        padding: 0 0.1rem;
        height: 1rem;
        width: 100%;
      }

      textarea {
        margin-top: -0.12rem;
        width: 100%;
        height: 1.5rem;
        padding-bottom: 0.3rem;
      }

      .address {
        width: 5.46rem;

        .a {
          width: 5rem;
          font-size: 0.3rem;
        }

        .iconfont {
          font-size: 0.34rem;
        }
      }
    }

    .logo {
      padding: 0 0.28rem;

      .left {
        font-size: 0.3rem;
        line-height: 1.1rem;
        font-weight: 700;

        .a {
          font-weight: 500;
          color: #999;
        }
      }

      .pic {
        // margin-left: 0.12rem;
        width: 1.8rem;
        height: 1.8rem;
      }
    }

    .license {
      padding: 0 0.28rem;

      .left {
        font-size: 0.3rem;
        line-height: 1.1rem;
        font-weight: 700;
      }

      .pic {
        margin-left: 0.12rem;
        width: 3rem;
        height: 2.06rem;
      }

      .tips {
        width: 3rem;
        color: #999;
        font-size: 0.26rem;
        margin-top: 0.24rem;
        text-align: center;
      }
    }

    .card {
      padding: 0 0.8rem 0.6rem 0.4rem;

      .title {
        line-height: 1rem;
        font-size: 0.26rem;
      }

      .img_list {
        .item_1 {
          width: 3rem;

          .pic {
            width: 3rem;
            height: 2.06rem;
            margin-bottom: 0.24rem;
          }

          .tips {
            color: #999;
            font-size: 0.26rem;
            text-align: center;
          }
        }
      }
    }
  }

  .submit {
    width: 6.9rem;
    line-height: 0.9rem;
    text-align: center;
    background-color: #0e98fd;
    color: #fff;
    border-radius: 0.45rem;
    margin: 0.6rem 0.3rem 0.3rem;
  }
}

.addressWrapper {
  .btns {
    width: 100%;
    height: 0.86rem;
    position: fixed;
    bottom: 6rem;
    left: 0;
    z-index: 556;

    background-color: #fff;
    text-align: center;
    font-size: 0.26rem;
    padding: 0 0.3rem;
    border-bottom: 0.01rem solid #eee;

    .cancel {
      color: #666;
    }

    .sure {
      color: #007aff;
    }
  }

  .pickerView {
    width: 100%;
    height: 6rem;
    position: fixed !important;
    bottom: 0;
    left: 0;
    z-index: 556;
    background-color: #fff;
    text-align: center;
  }
}

.detail {
  display: flex;
  align-items: center;
  margin-top: 0.2rem;
  margin-left: 0.24rem;
  color: #333;
}

.examine {
  padding: 0 0.3rem;
  text-align: right;
  color: #0e98fd;
  margin-bottom: 1rem;
}

.top {
  height: 1rem;
  display: flex;
  align-items: center;
  width: 100%;
  background-color: #fff;
  border-bottom: 1px solid #ccc;

  .top_type {
    width: 20%;
    height: 1rem;
    line-height: 1rem;
    text-align: center;
  }

  .om {
    color: #0e98fd;
    font-weight: bold;
    border-bottom: 2px solid #0e98fd;
  }
}

.shanchuB {
  background-color: #939394;
  height: 0.8rem;
  color: #fff;
  // line-height: 80rem;
  width: 5.8rem;
  padding: 0 0.3rem;
  display: flex;
  align-items: center;
  position: relative;

  .shanchuB2 {
    position: absolute;
    right: -1.5rem;
    top: 0.1rem;
    height: 0.6rem;
    width: 1.4rem;
    background-color: #0e98fd;
    border-radius: 0.3rem;
    line-height: 0.6rem;
    text-align: center;
    color: #fff;
  }
}

.jinggao {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0.2rem 0.3rem;
  min-height: 0.8rem;
}

.branch_list {
  position: absolute;
  top: 1rem;
  left: 0;
  width: 7.5rem;
  max-height: 4.4rem;
  overflow-y: auto;
  background-color: #f5f5f5;
  z-index: 1000;

  .contact_li {
    height: 0.8rem;
    line-height: 0.76rem;
    text-align: center;
    font-size: 0.28rem;
    color: #333;
    border-bottom: 1px solid #ccc;
  }
}

.report {
  position: fixed;
  top: 4rem;
  left: 0.6rem;
  width: 6.3rem;
  max-height: 6rem;
  background-color: #fff;
  z-index: 1000;
  border-radius: 20rem;
  overflow-y: auto;
  padding: 0.3rem;

  .report_top {
    position: relative;
    text-align: center;
    font-size: 0.3rem;
    font-weight: bold;
    margin-bottom: 0.4rem;

    .icon-baseline-close-px {
      position: absolute;
      right: 0rem;
      top: 0rem;
      font-size: 0.4rem;
      font-weight: normal;
    }
  }

  .subMercList {
    margin-bottom: 0.3rem;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
}

.attention {
  display: inline-block;
  height: 0.6rem;
  width: 1.2rem;
  line-height: 0.6rem;
  text-align: center;
  border-radius: 0.3rem;
  background-color: #0e98fd;
  font-size: 0.26rem;
  color: #fff;
}
.flex {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

img {
  display: block;
  width: 100%;
  height: auto;
}

.flex.flex_between {
  justify-content: space-between;
  -webkit-justify-content: space-between;
}
.flex.flex_around {
  justify-content: space-around;
  -webkit-justify-content: space-around;
}
.flex.ali_center {
  align-items: center;
  -webkit-align-items: center;
}
.flex.flex_center {
  justify-content: center;
  -webkit-justify-content: center;
}
.flex_col {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
}
.DatetimePicker {
  height: 6rem;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: #fff;
  z-index: 1000;
}
</style>
